import React from "react";
import {
  Area,
  AreaChart,
  Bar,
  BarChart,
  CartesianGrid,
  ResponsiveContainer,
  Tooltip,
  XAxis,
  YAxis,
  Cell,
  Legend,
} from "recharts";

export function BvsTrendChart({ data }) {
  return (
    <div className="h-[220px] w-full" data-testid="bvs-trend-chart">
      <ResponsiveContainer width="100%" height="100%">
        <AreaChart data={data} margin={{ top: 8, right: 10, left: -20, bottom: 0 }}>
          <defs>
            <linearGradient id="bvs" x1="0" y1="0" x2="0" y2="1">
              <stop offset="0%" stopColor="#09090b" stopOpacity={0.2} />
              <stop offset="100%" stopColor="#09090b" stopOpacity={0} />
            </linearGradient>
          </defs>
          <CartesianGrid stroke="#e4e4e7" vertical={false} />
          <XAxis
            dataKey="label"
            axisLine={false}
            tickLine={false}
            tick={{ fontSize: 11, fill: "#71717a" }}
          />
          <YAxis
            domain={[0, 100]}
            axisLine={false}
            tickLine={false}
            tick={{ fontSize: 11, fill: "#71717a" }}
          />
          <Tooltip
            contentStyle={{
              background: "#0a0a0a",
              border: "none",
              fontSize: 12,
              color: "#fafafa",
              borderRadius: 4,
            }}
          />
          <Area
            type="monotone"
            dataKey="bvs"
            stroke="#09090b"
            strokeWidth={2}
            fill="url(#bvs)"
          />
        </AreaChart>
      </ResponsiveContainer>
    </div>
  );
}

export function SovBarChart({ data, brand }) {
  return (
    <div className="h-[220px] w-full" data-testid="sov-chart">
      <ResponsiveContainer width="100%" height="100%">
        <BarChart data={data} layout="vertical" margin={{ top: 8, right: 20, left: 0, bottom: 0 }}>
          <CartesianGrid stroke="#e4e4e7" horizontal={false} />
          <XAxis
            type="number"
            domain={[0, 100]}
            axisLine={false}
            tickLine={false}
            tick={{ fontSize: 11, fill: "#71717a" }}
            unit="%"
          />
          <YAxis
            dataKey="name"
            type="category"
            axisLine={false}
            tickLine={false}
            tick={{ fontSize: 11, fill: "#27272a" }}
            width={120}
          />
          <Tooltip
            contentStyle={{
              background: "#0a0a0a",
              border: "none",
              fontSize: 12,
              color: "#fafafa",
              borderRadius: 4,
            }}
            formatter={(v) => `${v}%`}
          />
          <Bar dataKey="value" radius={[0, 2, 2, 0]}>
            {data.map((entry, idx) => (
              <Cell
                key={idx}
                fill={entry.name === brand ? "#09090b" : "#a1a1aa"}
              />
            ))}
          </Bar>
        </BarChart>
      </ResponsiveContainer>
    </div>
  );
}

export function SentimentTrendChart({ data }) {
  return (
    <div className="h-[240px] min-h-[240px] w-full" data-testid="sentiment-trend-chart">
      <ResponsiveContainer width="100%" height="100%">
        <BarChart
          data={data}
          stackOffset="expand"
          margin={{ top: 8, right: 12, left: -12, bottom: 0 }}
        >
          <CartesianGrid stroke="#e4e4e7" vertical={false} />
          <XAxis
            dataKey="week"
            axisLine={false}
            tickLine={false}
            tick={{ fontSize: 10, fill: "#71717a" }}
          />
          <YAxis
            tickFormatter={(v) => `${Math.round(v * 100)}%`}
            axisLine={false}
            tickLine={false}
            tick={{ fontSize: 11, fill: "#71717a" }}
            domain={[0, 1]}
          />
          <Tooltip
            contentStyle={{
              background: "#0a0a0a",
              border: "none",
              fontSize: 12,
              color: "#fafafa",
              borderRadius: 4,
            }}
            formatter={(v, name) => [v, name]}
            labelFormatter={(l) => `Week ${l}`}
          />
          <Legend wrapperStyle={{ fontSize: 11 }} />
          <Bar dataKey="positive" name="Positive" stackId="a" fill="#10b981" />
          <Bar dataKey="neutral" name="Neutral" stackId="a" fill="#a1a1aa" />
          <Bar dataKey="negative" name="Negative" stackId="a" fill="#e53935" />
        </BarChart>
      </ResponsiveContainer>
    </div>
  );
}
